export default __webpack_public_path__ + "static/media/img-01-mini.d2086f62.png";